<template>
  <div >
    <el-card class="box-card" >
        <div class="detail" v-if="id==1" @click="turn">
            <p><img src="@/assets/sspg/sspg_01.jpg" /></p>
            <p><img src="@/assets/sspg/sspg_02.jpg" /></p>
            <p><img src="@/assets/sspg/sspg_03.jpg" /></p>
            <p><img src="@/assets/sspg/sspg_04.jpg" /></p>
            <p><img src="@/assets/sspg/sspg_05.jpg" /></p>
            <p><img src="@/assets/sspg/sspg_06.jpg" /></p>
            <p><img src="@/assets/sspg/sspg_07.jpg" /></p>
            <p><img src="@/assets/sspg/sspg_08.jpg" /></p>
            <p><img src="@/assets/sspg/sspg_09.jpg" /></p>
        </div>
        <div class="detail" v-if="id==2" @click="turn">
            <p><img src="@/assets/yf/yf_01.jpg" /></p>
            <p><img src="@/assets/yf/yf_02.jpg" /></p>
            <p><img src="@/assets/yf/yf_03.jpg" /></p>
            <p><img src="@/assets/yf/yf_04.jpg" /></p>
            <p><img src="@/assets/yf/yf_05.jpg" /></p>
            <p><img src="@/assets/yf/yf_06.jpg" /></p>
            <p><img src="@/assets/yf/yf_07.jpg" /></p>
            <p><img src="@/assets/yf/yf_08.jpg" /></p>
        </div>
        <div class="detail" v-if="id==3||id==4" @click="turn">
            <p><img src="@/assets/et/et_01.jpg" /></p>
            <p><img src="@/assets/et/et_02.jpg" /></p>
            <p><img src="@/assets/et/et_03.jpg" /></p>
            <p><img src="@/assets/et/et_04.jpg" /></p>
            <p><img src="@/assets/et/et_05.jpg" /></p>
            <p><img src="@/assets/et/et_06.jpg" /></p>
            <p><img src="@/assets/et/et_07.jpg" /></p>
            <p><img src="@/assets/et/et_08.jpg" /></p>
            <p><img src="@/assets/et/et_09.jpg" /></p>
            <p><img src="@/assets/et/et_10.jpg" /></p>
        </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'Detail',
  data : function(){
    return {
        id : null
    }
  },
  created() {
      this.id = this.$route.params.id
  },
  methods : {
      turn(){
          console.log(111)
          this.$router.push({
              name : 'Buy'
          })
      }
  }
}
</script>

<style>
.detail p{
    margin: 0;
    padding: 0;
}
.detail img{
    display: block;
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/Detail.vue